/**
 * Cart page — require terms checkbox before checkout.
 */
(function () {
  function getTos() {
    return document.getElementById('cart_tos_agree');
  }

  function isChecked() {
    var tos = getTos();
    return tos && tos.checked;
  }

  function warn() {
    var form = document.getElementById('cart_form');
    if (!form || form.querySelector('.psm-tos-warning')) return;
    var p = document.createElement('p');
    p.className = 'warning animated bounceIn psm-tos-warning';
    p.setAttribute('role', 'alert');
    p.textContent =
      (window.PXUTheme &&
        window.PXUTheme.translation &&
        window.PXUTheme.translation.agree_to_terms_warning) ||
      'You must agree with the terms and conditions to checkout.';
    var anchor = form.querySelector('.tos_warning') || form.querySelector('#psm-cart-checkout');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(p, anchor);
    }
  }

  function block(e) {
    if (isChecked()) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    warn();
    var tos = getTos();
    if (tos) {
      tos.focus();
      if (tos.scrollIntoView) tos.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return false;
  }

  function goCheckout() {
    var form = document.getElementById('cart_form');
    if (!form || !isChecked()) return;
    var existing = form.querySelector('input[name="checkout"][type="hidden"]');
    if (existing) existing.remove();
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout';
    input.value = '';
    form.appendChild(input);
    form.submit();
  }

  function bind() {
    var form = document.getElementById('cart_form');
    var tos = getTos();
    var btn = document.getElementById('psm-cart-checkout');
    if (!form || !tos || !btn) return;

    form.addEventListener('submit', function (e) {
      if (!isChecked()) block(e);
    }, true);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!isChecked()) {
        block(e);
        return;
      }
      goCheckout();
    });

    document.querySelectorAll('.Sticky_checkout_button').forEach(function (sticky) {
      sticky.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          if (!isChecked()) {
            block(e);
            return;
          }
          btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          btn.click();
        },
        true
      );
    });

    tos.addEventListener('change', function () {
      var w = form.querySelector('.psm-tos-warning');
      if (w && tos.checked) w.remove();
    });
  }

  window.psmCartTosBind = bind;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
